import dayjs from "dayjs";

import { CheckinsByCompany, CheckinsCompanyActives } from "./checkins.types";

type GroupQueueByDaysParams = {
  response: CheckinsCompanyActives[];
  arg: CheckinsByCompany["args"];
};
export function groupCheckinsByDays({ response, arg }: GroupQueueByDaysParams) {
  const dateFormat = arg?.dateFormat || "DD/MM";

  const responseByDays = response.reduce<CheckinsByCompany["result"]["grouped"]>((acc, checkin) => {
    if (!checkin.createdAt) return acc;

    const dateObj = dayjs(checkin.createdAt);
    const nowYear = dayjs().year();
    const dateYear = dateObj.year();
    const key = dateYear !== nowYear ? dateObj.format("DD/MM/YYYY") : dateObj.format(dateFormat);
    const existingEntry = acc.find((entry) => entry.date === key);

    if (existingEntry) {
      existingEntry.queues.push(checkin);
      existingEntry.length = existingEntry.queues.length;
    } else {
      acc.push({
        date: key,
        length: 1,
        queues: [checkin]
      });
    }

    return acc;
  }, []);

  return {
    original: response,
    grouped: responseByDays
  };
}
